import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import ConsultaLoteList from './ConsultaLoteList';
import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import ConsultaLoteCadastrar from './ConsultaLoteCadastrar';
import { Messages } from 'primereact/messages';
import postConsultaLote from '../../service/postConsultaLote';

export default function ConsultaLotePage() {
  const { t } = useTranslation();
  const msgs = useRef<Messages>(null);
  const [consultaLote, setConsultaLote] = useState<any | null>(null);
  const labelButton = t('cadastrar')
  const save = (consultaLote:any) => {
    
    postConsultaLote(consultaLote).then(data => {
        if(data.includes('Erro')){
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }
               
            ]);
          }
        }
        else{
          setConsultaLote(null);
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
               
            ]);
          }
        }
      })
    
    
    
  }
  const startContent = (
    <React.Fragment>
        <Button label={labelButton} icon="pi pi-plus" style={{backgroundColor:'#183462'}} onClick={() => {setConsultaLote({})}}/>
    </React.Fragment>
);

  return (
    <Container>
      <div className="row">
          <div className="col-lg-12 mb-3">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
              <h1 className="h3 mb-0 text-gray"><i className="pi pi-desktop" style={{ fontSize: '2.0rem' }}></i> {t('consultaLote')}</h1>
            </div>     
          </div>
      </div>
      <div className="card">
        <Messages ref={msgs} />
        {!consultaLote && (
          <>
            <Toolbar start={startContent} />
            <br></br>
            <br></br>
            <ConsultaLoteList></ConsultaLoteList>
          </>
        )}
        {consultaLote && (
          <>
           <ConsultaLoteCadastrar msgs={msgs} consultaLote={consultaLote} onSave={save} onClose={() => {setConsultaLote(null)}}></ConsultaLoteCadastrar>
          </>
        )}
      </div>
                
    </Container>
  )
}
